import {
    MOVE_STEPS,
    UPDATE_STEP_PARAMETER,
    UPDATE_PARAMETER,
    UPDATE_TRACK_VOLUME,
    SNAP_TO_GRID,
    MOVE_AUTOMATION_BREAK_POINT,
    MOVE_AUTOMATION_BREAK_POINTS,
    } from './constants.js';
import {areContentIdsEqual} from './actions/contentIds.js';

/**
 * Given an action we want to enqueue and a list of 
 * queued actions, this function returns a list with
 * all redundant actions removed or collapsed.
 */
export const pruneRedundantActions = (serialized, actions) => {
    let action = serialized.operation;

    // first check if this type needs to be reduced,
    // instead of pruned
    if (isAdditiveType(action.type)) {
        return reduceRedundantActions(serialized, actions);
    }

    // otherwise we must prune 
    let index = actions.length - 1;
    for ( ; index >= 0; index--) {
        let _action = actions[index];
        
        if (!isPrunable(action, _action)) {
            break;
        }
    }

    let _action = actions[index + 1];
    if (_action && _action.operation.payload.savedValue !== undefined) {
        // basically in order to retain the undo information
        // of the action we are pruning, we need to copy over
        // the saved value
        serialized.operation.payload.savedValue =
            _action.operation.payload.savedValue;
    }

    // we return all actions up until the first non-prunable action
    // note: we will ultimately append the given action onto this list,
    // to form the new queuedActions list
    return [... actions.slice(0, index + 1), serialized];
};

const reduceRedundantActions = (serialized, actions) => {
    let summedAction = serialized.operation;
    let index = actions.length - 1;
    for ( ; index >= 0; index--) {
        let _action = actions[index];
        
        if (isPrunable(summedAction, _action)) {
            // then we must add the types
            summedAction = sumActions(summedAction, _action.operation);
        } else {
            index++;
            break;
        }
    }
    return [... actions.slice(0, index), {
        ... serialized,
        operation: summedAction
    }];
};

// each type will determine if two actions are "EQUIVALANT" 
// todo: take out code that determines whether two actions
// can be "SUMMED"

export function isPrunable(actionA, actionB) {
    if (actionB.length) {
        actionB = actionB[actionB.length - 1];
    }

    if (actionB.operation) {
        actionB = actionB.operation;
    }

    if (actionA.type !== actionB.type &&
        !(actionA.type === SNAP_TO_GRID && actionB.type === MOVE_STEPS)) {
        return false;
    }

    if (!isPrunableType(actionA.type)) {
        return false;
    }

    // content id is the identifying id for any object
    return areContentIdsEqual(actionA.contentId, actionB.contentId);
}

export const isAdditiveType = (type) => {
    return ADDITIVE_TYPES.has(type);
}

const ADDITIVE_TYPES = new Set([
    MOVE_STEPS,
    SNAP_TO_GRID,
  //  UPDATE_STEP_DURATIONS,
]);

export const isPrunableType = (type) => {
    return PRUNABLE_TYPES.has(type);
}

const PRUNABLE_TYPES = new Set([
    UPDATE_STEP_PARAMETER,
 //   UPDATE_STEP_DURATIONS,
    //UPDATE_PARAMETER,
    UPDATE_TRACK_VOLUME,
    MOVE_AUTOMATION_BREAK_POINT,
    MOVE_AUTOMATION_BREAK_POINTS,
    MOVE_STEPS,
    SNAP_TO_GRID
]);

const sumActions = (actionA, actionB) => {
    let payloadA = actionA.payload;
    let payloadB = actionB.payload;

    if (actionA.type === MOVE_STEPS) {
        let transformationA = payloadA.transformation;
        let transformationB = payloadB.transformation;
        let summedTransformation = {
            stepDifference: transformationA.stepDifference + transformationB.stepDifference,
            transposeDifference: transformationA.transposeDifference + transformationB.transposeDifference,
        };
            
        return {
            ... actionB,
            payload: {
                ... payloadB,
                transformation: summedTransformation
            },
        };
    }

    /*
    if (actionA.type === UPDATE_STEP_DURATIONS) {
        // this is actually multiplicative, but who cares
        let factor = payloadA.factor * payloadB.factor;
        return {
            ... actionB,
            payload: {
                ... payloadB,
                factor: factor
            }
        };
    }
    */

    if (actionA.type === SNAP_TO_GRID &&
        actionB.type === MOVE_STEPS) {
        let snapStepNumbers = actionA.payload.stepLocations;
        let oldTransformation = payloadB.transformation;
        let newTransformation = {
            stepDifference: oldTransformation.stepDifference + snapStepNumbers[0].stepDifference,
            transposeDifference: oldTransformation.transposeDifference + snapStepNumbers[0].transposeDifference
        };

        return {
            ... actionB,
            payload: {
                ... payloadB,
                transformation: newTransformation
            }
        };
    }

    return actionA;
};
